angular.module('wbComponents').controller 'DocumentEditController',

['$scope', 'railsResource', 'users', 'FileAsset'
($scope, $resource, users, FileAsset) ->
    $scope.sender = users.getCurrentUser()
    $scope.state = state = {}
    $scope.resetForm = ->
      $scope.state = state = {}
      state.error = state.success = state.updating = false
      if $scope.auth.hasRole('staff')
        $scope.categories = [
          { name: 'General Document', value: 'document' },
          { name: 'Identification', value: 'identification'},
          { name: 'Identification Back', value: 'identification_back'},
          { name: 'Bank Statement', value: 'bank_statement'},
          { name: 'Bank Document', value: 'bank_info'},
          { name: 'Credential', value: 'credential'},
        ]

    $scope.update = (form) ->
      state.message = 'Fields must be filled out correctly' if form.$invalid
      return unless state.updating is false and form.$valid
      state.updating = true
      state.message = null
      FileAsset.get(id: $scope.doc.id, (doc) ->
        doc.message = $scope.message
        doc.title = $scope.title
        doc.category = $scope.category
        doc.$update ->
          $scope.documentEditDialog.hide()
      )

    $scope.$on('edit_document', (event, doc) ->
      $scope.resetForm()
      $scope.title = doc.title
      $scope.message = doc.message
      $scope.category = doc.category
      $scope.doc = doc
      $scope.documentEditDialog.show()
    )
]
